interface IProps {
    value: string;
    onChange: (value: string) => void;
}

function IdFilter({ value, onChange }: IProps) {
    return (
        <label>
            ID:
            <input type="text" value={value} onChange={(e) => onChange(e.currentTarget.value)} />
        </label>
    );
}

export default IdFilter;
